import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Token, TokenInterface } from '@models/token';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  hasError = false;
  private headers: HttpHeaders;
  private token?: Token;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({
      "Content-type": "application/json",
      "Accept": "application/json"
    });
  }

  login(email: string, password: string): boolean {
    let resp = this.http.post<TokenInterface>(
      environment.baseUrl + 'token/',
      {"username": email, "password": password},
      {
        headers: this.headers.append("skip", "true")
      })
        .subscribe({
          next: (res) => this.cacheToken(Token.fromJson(res)),
          error: () => { this.hasError = true; }
        });
     if (this.hasError) return false;

     return true;   
  }

  private cacheToken(token: Token) {
    this.token = token;
    localStorage.setItem('token', JSON.stringify(token.toJson()));
  }

  public isAuthorized(): boolean {
    const token = this.getToken();

    if (token) {
      let currentTime = new Date().getTime();
      let expiryTime = new Date(token.expiry).getTime();
      return expiryTime >= currentTime ? true : false;
    }
    return false;
  }

  public getToken(): Token | null {
    // if the token is set return it right away
    if (this.token) {
      return this.token;
    }
    // check local storage for a cached copy if not
    const storage = localStorage.getItem('token');
    if (storage) {
      this.token = JSON.parse(storage) as Token;
    }
    return this.token ? this.token : null;
  }
}
